import { useMutation } from "react-query";
import { checkVendorDuplicate } from "../../../../actions/CarrierAgreementMgmt/Vendor";

const useVendorDuplicateChecker = () => {
  return useMutation(checkVendorDuplicate);
};
export default useVendorDuplicateChecker;
